<div class="flex flex-col gap-6">
  <xemex-insights-configuration></xemex-insights-configuration>
  <p class="insights-time-zone">{{ timeZoneNote() }}</p>

  @if (showTelemetryNotShared()) {
    <xemex-no-items-found
      NoItemsIllustration="device"
      [message]="'devices.detailTabs.insights.notShared'"
      [showRefresh]="false"
    ></xemex-no-items-found>
  } @else if (hasNoData()) {
    <xemex-no-items-found
      NoItemsIllustration="device"
      [message]="'devices.detailTabs.insights.noData'"
      [showRefresh]="false"
    ></xemex-no-items-found>
  } @else {
    <xemex-card-grid>
      @if (hasGridContext()) {
        <xemex-card [title]="'devices.detailTabs.insights.grid.title' | translate">
          <div>
            <xemex-emeter-insights
              [selectedInsightContexts]="gridContext"
              [meterRole]="meterRole()"
            ></xemex-emeter-insights>
          </div>
        </xemex-card>
      }

      @if (hasEnergyContext()) {
        <xemex-card [title]="'devices.detailTabs.insights.energy' | translate">
          @if (energyTotals(); as totals) {
            <div cardHeaderActions class="period-totals">
              @if (totals.imported) {
                <div class="period-totals__item">
                  <span class="period-totals__label">
                    {{ 'devices.detailTabs.insights.consumed' | translate }}
                  </span>
                  <span class="period-totals__value">{{ totals.imported }}</span>
                </div>
              }
              @if (totals.exported) {
                <div class="period-totals__item">
                  <span class="period-totals__label">
                    {{ 'devices.detailTabs.insights.delivered' | translate }}
                  </span>
                  <span class="period-totals__value">{{ totals.exported }}</span>
                </div>
              }
            </div>
          }
          <div>
            <xemex-emeter-insights
              [selectedInsightContexts]="energyContext"
              [meterRole]="meterRole()"
            ></xemex-emeter-insights>
          </div>
        </xemex-card>
      }

      @if (hasPerformanceContext()) {
        <xemex-performance-ratio-insights
          [ratios]="performanceRatios()"
          [trend]="performanceTrend()"
          [anchorDate]="performanceAnchorDate()"
          [loading]="pvPerformanceStore.isLoading()"
        ></xemex-performance-ratio-insights>
      }

      @if (hasPowerData()) {
        <xemex-card [title]="'devices.detailTabs.insights.power' | translate">
          <div>
            <xemex-electrical-insights
              metric="power"
              [phaseCountOverride]="phaseCountOverride()"
              [meterRole]="meterRole()"
            ></xemex-electrical-insights>
          </div>
        </xemex-card>
      }

      @if (hasVoltageData()) {
        <xemex-card [title]="'devices.detailTabs.insights.voltage' | translate">
          <div>
            <xemex-electrical-insights
              metric="voltage"
              [phaseCountOverride]="phaseCountOverride()"
              [meterRole]="meterRole()"
            ></xemex-electrical-insights>
          </div>
        </xemex-card>
      }

      @for (hp of heatpumpChannels(); track hp.channelNumber) {
        <xemex-card
          [title]="('devices.detailTabs.insights.temperature_flow' | translate) + ' – ' + hp.label"
        >
          <div>
            <xemex-heatpump-insights [channelNumber]="hp.channelNumber"></xemex-heatpump-insights>
          </div>
        </xemex-card>
      }
    </xemex-card-grid>

    @if (hasDataTable()) {
      <xemex-table
        style="max-height: 624px"
        [data]="dataTable().rows"
        [columns]="dataTable().columns"
        [pageable]="false"
        [compact]="true"
        [loading]="telemetryStore.isLoadingDeviceTelemetry()"
      ></xemex-table>
    }
  }
</div>
